module.exports = __webpack_public_path__ + "static/img/wealth_level_74.591b00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_74.png
// module id = VZBG
// module chunks = 0